import { schema } from 'normalizr'

const city = new schema.Entity('cities')

export default city
